import { SubmitHandler, useForm } from "react-hook-form";
import { Button, Col, Form, FormFeedback, Input, Label, Row } from "reactstrap";
import { Cancel, Save, SubTaskTitle, TaskTitleLabel } from "../../../../../constants";
import { useAppDispatch } from "../../../../../reduxToolkit/hooks";
import { addNewTask, setAddModal, setMyTask } from "../../../../../reduxToolkit/reducers/taskSlice";
import { AddTaskProps } from "../../../../../types/Applications";
import TaskRadioRow from "./TaskRadioRow";

const NewTaskModalForm = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const dispatch = useAppDispatch();

  const AddTask: SubmitHandler<AddTaskProps> = (data) => {
    if (data.title !== "" && data.subTitle !== "" && data.description !== "") {
      dispatch(addNewTask(data));
      dispatch(setMyTask(data));
      dispatch(setAddModal());
    }
  };

  return (
    <Form className="form-bookmark needs-validation" onSubmit={handleSubmit(AddTask)}>
      <Row>
        <Col md="12" className="mb-3 mt-0">
          <Label>{TaskTitleLabel}</Label>
          <input type="text" className={`form-control ${`${errors.title ? "is-invalid" : "is-valid"}`}`} {...register("title", { required: true })} />
          {errors.title && <FormFeedback className="text-danger">{"Title is required"}</FormFeedback>}
        </Col>
        <Col md="12" className="mb-3 mt-0">
          <Label>{SubTaskTitle}</Label>
          <input type="text" className={`form-control ${`${errors.subTitle ? "is-invalid" : "is-valid"}`}`} {...register("subTitle", { required: true })} />
          {errors.subTitle && <FormFeedback className="text-danger">{"Subtitle is required"}</FormFeedback>}
        </Col>
        <TaskRadioRow />
        <Col md="6" className="mb-3 mt-0">
          <Input type="select" className="form-control ">
            <option value="My Task">My Task</option>
          </Input>
        </Col>
        <Col md="6" className="mb-3 mt-0">
          <Input type="select" className={`js-example-disabled-results form-control`}>
            <option value="General">General</option>
          </Input>
        </Col>
        <Col md="12" className="mb-3 col-md-12 my-0">
          <textarea className={`form-control ${`${errors.description ? "is-invalid" : "is-valid"}`}`} {...register("description", { required: true })} />
          {errors.description && <FormFeedback className="text-danger">{"Description is required"}</FormFeedback>}
        </Col>
      </Row>
      <Button color="secondary" className="me-1" type="submit">{Save}</Button>
      <Button color="primary" onClick={() => dispatch(setAddModal())}>{Cancel}</Button>
    </Form>
  );
};
export default NewTaskModalForm;